<template>
  <div>
   <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            simpleshare.org
          </router-link>
        </div>
      </nav>
   </div>
    <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Get a typable URL to put some stuff.
          </h1>
          <h2 class="subtitle">
            like a long Google Slide URL
          </h2>
        </div>
      </div>
    </section>

    <div class="container ns-main-content">
      <form @submit.prevent="onSubmitGetRoom()">
        <b-field :label="!isTaken ? `It will be like: http://simpleshare.org/${spaceSlug}` : `Name is Taken: http://simpleshare.org/${spaceSlug}`" :label-position="labelPosition">
          <div class="control">
            <input class="input is-large" :class="{ 'is-danger': isTaken }" type="text" v-model="spaceID" @input="tryCheckTaken()">
          </div>
        </b-field>
        <b-message v-if="isTaken" type="is-danger">
          Name is taken
          <a target="_blank" :href="'/' + spaceSlug">https://simpleshare.org/{{ spaceSlug }}</a>
        </b-message>

        <b-field label="Stuff to put there." :label-position="labelPosition">
          <div class="control">
            <textarea class="textarea is-large"  type="text" v-model="regContent"></textarea>
          </div>
        </b-field>

        <b-field :label="`Password for editing that in the future.`" :label-position="labelPosition">
          <div class="control">
            <input class="input is-large" autocomplete="passgate-of-spaceID" type="password" @keydown.enter="onSubmitGetRoom()" v-model="regPW">
          </div>
        </b-field>

        <b-message v-if="wranMustHaveURL" type="is-danger">
          Please enter URL name
        </b-message>
        <b-message v-if="wranMustHaveContent" type="is-danger">
          Please enter Some Content
        </b-message>
        <b-message v-if="wranMustHavePassword" type="is-danger">
          Please enter a Password
        </b-message>

        <b-message v-if="checking" type="is-info">
          Checking....
        </b-message>

        <b-button size="is-large is-primary" @click="onSubmitGetRoom()">Get My Typable URL</b-button>

      </form>

    </div>

  </div>
</template>

<script>
import slugify from 'slugify'
import * as API from '../network/api.js'
import randomWords from 'random-words'
export default {
  components: {
  },
  data () {
    return {
      canGo: false,
      wranMustHaveContent: false,
      wranMustHavePassword: false,
      wranMustHaveURL: false,
      labelPosition: 'outside',
      regPW: '',
      regContent: '',
      checking: false,
      isTaken: false,
      spaceID: randomWords({ exactly: 2, maxLength: 5 }).join('-')
    }
  },
  mounted () {
  },
  computed: {
    spaceSlug () {
      return slugify(this.spaceID, {
        replacement: '-',
        remove: `'`,
        lower: true
      })
      /* eslint-disable */
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
      /* eslint-disable */
    }
  },
  methods: {
    async tryCheckTaken () {
      try {
        let isTaken = await API.getNameSpaceBySpaceID({ spaceID: this.spaceSlug })
        this.isTaken = isTaken
      } catch (e) {
        this.isTaken = false
      }
    },
    async onSubmitGetRoom () {
      let noGo = false
      let isTaken = await API.getNameSpaceBySpaceID({ spaceID: this.spaceSlug })
      if (isTaken) {
        this.isTaken = true
        noGo = true
      }
      if (!this.spaceSlug) {
        this.wranMustHaveURL = true
        noGo = true
      } else {
        this.wranMustHaveURL = false
      }
      if (!this.regContent) {
        this.wranMustHaveContent = true
        noGo = true
      } else {
        this.wranMustHaveContent = false
      }
      if (!this.regPW) {
        this.wranMustHavePassword = true
        noGo = true
      } else {
        this.wranMustHavePassword = false
      }
      if (noGo) {
        return
      }
      await API.createSpace({
        spaceID: this.spaceSlug,
        password: this.regPW,
        content: this.regContent
      })
      this.$router.push('/' + this.spaceSlug)
      setTimeout(() => {
        window.alert('successfully created a URL')
      }, 100)
    }
  }
}
</script>

<style>

</style>
